<template>
    <div class="upload" :class="{disabled, error, over}" @dragover.prevent="dragover" @drop.prevent="drop">
        <div class="upload-progress" ref="progress" :class="{uploading, complete: url, progress}"></div>
        <div class="select-file flex flex-align flex-center" v-if="!url">
            <div v-if="!progress">
                Drag &amp; Drop or <a class="text-button" @click="choose">Select a File</a>
            </div>
            <spinner v-if="progress" />
            <div class="hidden-file-input">
                <input class="file-input" accept="*/*" type="file" @change="choose" ref="input" />
            </div>
        </div>
        <div class="file-selected flex flex-align" v-if="url">
            <div class="upload-thumbnail-container">
                <img class="upload-thumbnail" :src="thumbnail" />
            </div>
            <div class="ff">
                <div class="upload-title">Uploaded File</div>
                <div class="upload-status">Done</div>
            </div>
            <a class="text-button red" :class="{disabled: !url}" @click="remove">Remove</a>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    
    export default {
        name: 'Upload',
        props: {
            error: Boolean,
            disabled: Boolean,
            convert: Boolean,
            url: String
        },
        computed: {
            status(){
                if(this.uploading){
                    return 'Uploading';
                }else{
                    return 'Done';
                }
            },
            thumbnail(){
                if(this.url){
                    if(['.png', '.jpg'].includes(this.url.slice(-4))){
                        return this.url.slice(0, -4) + '_thumb.jpg';
                    }else{
                        return this.url;
                    }
                }{
                    return '';
                }
            }
        },
        data(){
            return {
                uploading: false,
                progress: false,
                over: false
            };
        },
        methods: {
            remove(){
                this.$emit('update:url', '');
                this.$emit('input', '');
            },
            choose(){
                if(this.$refs.input.files.length){
                    this.upload(this.$refs.input.files[0]);
                }
            },
            dragover($event){
                $event.stopPropagation();

                if(this.timeout){
                    clearTimeout(this.timeout);
                }

                this.over = true;

                this.timeout = setTimeout(() => {
                    this.over = false;
                    this.timeout = null;
                }, 100);
            },
            drop($event){
                $event.stopPropagation();

                const files = [];

                for(const file of $event.dataTransfer.files){
                    if(file.size){
                        files.push(file);
                    }
                }

                if(files.length){
                    this.upload(files[0]);
                }
            },
            upload(file){
                this.progress = true;
                this.uploading = true;

                const form = new FormData();

                form.append('blur', false);
                form.append('thumb', '250x250');
                form.append('filename', file.filename);
                form.append('file', file);

                axios.post(`https://convert.atlas.school/convert`, form,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                .then(response => {
                    this.uploading = false;
                    this.$emit('update:url', response.data.url);
                    this.$emit('input', response.data.url);
                    setTimeout(() => this.progress = false, 1000);
                })
                .catch(error => {
                    this.progress = false;
                    setTimeout(() => this.uploading = false, 500);
                    console.log(error);
                });
            }
        }
    }
</script>

<style scoped lang="less">
    @import "~@/assets/less/variables";
    @import "~@/assets/less/mixins";

    .upload
    {
        border: 1px solid @d;
        border-radius: 3px;
        overflow: hidden;

        &.over
        {
            border-color: @base;
            box-shadow: 0 0 0 3px fade(@base, 30%);
        }
    }

    .upload-progress
    {
        height: 2px;
        background: @base;
        position: absolute;
        top: 0;
        left: 0;
        width: 0%;
        transition: all ease 0.3s;
        opacity: 0;
        pointer-events: none;

        &.uploading
        {
            width: 50%;
        }

        &.complete
        {
            width: 100%;
        }

        &.progress
        {
            opacity: 1;
        }
    }

    .select-file
    {
        height: 70px;
        padding: 20px;
        color: @darkgrey;
        font-size: 14px;
        font-weight: 600;
    }

    .file-selected
    {
        padding: 15px;
    }

    .hidden-file-input
    {
        position: absolute;
        top: 0;
        left: 0;
        display: block;
        bottom: 0;
        right: 0;
        overflow: hidden;
        opacity: 0.01;

        .file-input
        {
            cursor: pointer;
            width: 999px;
            height: 999px;
            line-height: 999px;
            font-size: 999px;
        }
    }

    .upload-thumbnail-container
    {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        background: @e;
        margin-right: 15px;

        &::after
        {
            .absolute(0, 0, 0, 0);
            content: "";
            z-index: 2;
            border: 1px solid rgba(0, 0, 0, 0.1);
            border-radius: 50%;
        }
    }

    .upload-thumbnail
    {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        object-fit: cover;
    }

    .upload-title
    {
        line-height: 16px;
        font-size: 14px;
        color: @black;
        font-weight: 600;
        margin-bottom: 4px;
    }

    .upload-status
    {
        font-size: 12px;
        line-height: 14px;
    }
</style>
